/**
 * This collection defines the core event types.
 *
 * @public
 */
export const CoreEvents = {
  /**
   * This event type is used to signal an error to event listeners.
   *
   * @public
   */
  error: 'ev_err',

  /**
   * This event type is used to signal a warning to event listeners.
   *
   * @public
   */
  warning: 'ev_warn',
}
